import styled from 'styled-components';

export const FieldInputTitle = styled.div`
  color: ${(props) => props.theme.colors.muted};
`;

export const FullWideContentBlock = styled.div`
  width: 100%;
`;

export const TextareaSublabel = styled.p`
  color: ${(props) => props.theme.colors.muted};
  line-height: 20px;
  font-size: 12px;
`;
